var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4439 30.1486C24.0123 30.1486 30.1476 24.0133 30.1476 16.4449C30.1476 8.87657 24.0123 2.74121 16.4439 2.74121C8.87559 2.74121 2.74023 8.87657 2.74023 16.4449C2.74023 24.0133 8.87559 30.1486 16.4439 30.1486Z",
    fill: "#181717",
    stroke: "#181717",
    strokeWidth: 2.74074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1348_4917)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1348_4917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9803 10.2784C23.3242 10.7412 22.5977 11.0952 21.8288 11.3267C21.4162 10.8522 20.8678 10.5159 20.2577 10.3633C19.6477 10.2107 19.0055 10.249 18.418 10.4733C17.8306 10.6975 17.3261 11.0968 16.9729 11.617C16.6197 12.1373 16.4349 12.7535 16.4433 13.3823V14.0674C15.2392 14.0987 14.046 13.8316 12.9701 13.2901C11.8942 12.7485 10.9689 11.9493 10.2766 10.9636C10.2766 10.9636 7.53588 17.1302 13.7025 19.871C12.2914 20.8288 10.6104 21.3091 8.90625 21.2413C15.0729 24.6673 22.61 21.2413 22.61 13.3617C22.6093 13.1709 22.591 12.9805 22.5551 12.793C23.2544 12.1034 23.7479 11.2326 23.9803 10.2784Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.37037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1348_4917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2667,
    height: 17.2667,
    fill: "white",
    transform: "translate(7.40039 7.40039)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1348_4917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4444,
    height: 16.4444,
    fill: "white",
    transform: "translate(8.22266 8.22266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c2e6cfd3d96aa257e248d71c5d38d791.svg";
export { ForwardRef as ReactComponent };